const routes = [
    {
        path: 'static',
        redirect: { name: 'StatsMonthly' },
        children: [
            // 환경설정 > 접속통계
            {
                path: 'monthly',
                name: 'StatsMonthly',
                meta: { menu: 'static', keepAlive: true },
                component: () => import('@/pages/cmsMng/configSetting/static/MonthStatView.vue'),
            },
            {
                path: 'daily',
                name: 'StatsDaily',
                meta: { menu: 'static', keepAlive: true },
                component: () => import('@/pages/cmsMng/configSetting/static/DailyStatView.vue'),
            },
            {
                path: 'timely',
                name: 'StatsTimely',
                meta: { menu: 'static', keepAlive: true },
                component: () => import('@/pages/cmsMng/configSetting/static/TimeStatView.vue'),
            },
            {
                path: 'cms',
                name: 'StatCms',
                meta: { menu: 'static', keepAlive: true },
                component: () => import('@/pages/cmsMng/configSetting/static/CmsStatView.vue')
            },
        ]
    },
    {
        path: 'satis',
        redirect: { name: 'SatisList' },
        children: [
            // 환경설정 > 만족도조사 통계
            {
                path: 'stat',
                name: 'SatisList',
                meta: { menu: 'stat', keepAlive: true },
                component: () => import('@/pages/cmsMng/configSetting/satis/SatisListView.vue'),
            },
        ]
    },
    {
        path: 'board-stats',
        name: 'BoardStatList',
        meta: { menu: 'board-stats', keepAlive: true },
        component: () => import('@/pages/cmsMng/configSetting/boardStat/BoardStatView.vue')
    },
    {
        path: 'cmm-code',
        redirect: { name: 'CmmCodeList' },
        children: [
            // 환경설정 > 공통코드관리
            {
                path: 'list',
                name: 'CmmCodeList',
                meta: { menu: 'cmm-code', keepAlive: true },
                component: () => import('@/pages/cmsMng/configSetting/cmmCode/CmmCodeListView.vue')
            },
        ]
    },
    {
        path: 'program',
        redirect: { name: 'ProgramList' },
        children: [
            // 환경설정 > 프로그램관리
            {
                path: 'list',
                name: 'ProgramList',
                meta: { menu: 'program', keepAlive: true },
                component: () => import('@/pages/cmsMng/configSetting/program/ProgramListView.vue')
            },
            {
                path: 'add',
                name: 'ProgramInsert',
                meta: { menu: 'program', keepAlive: false },
                component: () => import('@/pages/cmsMng/configSetting/program/ProgramInsertView.vue')
            },
            {
                path: 'modify/:prgrmId',
                name: 'ProgramUpdate',
                meta: { menu: 'program', keepAlive: false },
                component: () => import('@/pages/cmsMng/configSetting/program/ProgramUpdateView.vue'),
                props: true,
            },
            {
                path: 'page/:prgrmId',
                name: 'ProgramPageView',
                meta: { menu: 'program', keepAlive: false },
                component: () => import('@/pages/cmsMng/configSetting/program/ProgramPageView.vue'),
                props: true,
            },
        ]
    },
    {
        path: 'cntn-ip',
        redirect: { name: 'CntnIpList' },
        children: [
            // 환경설정 > 접속IP관리 목록
            {
                path: 'list',
                name: 'CntnIpList',
                meta: { menu: 'cntnIp', keepAlive: true },
                component: () => import('@/pages/cmsMng/configSetting/cntnIp/CntnIpListView.vue')
            },
            // 접속IP관리 등록
            {
                path: 'add',
                name: 'CntnIpInsert',
                meta: { menu: 'cntnIp', keepAlive: false },
                component: () => import('@/pages/cmsMng/configSetting/cntnIp/CntnIpInsertView.vue')
            },
            // 접속IP관리 수정
            {
                path: 'modify/:cntnIpId',
                name: 'CntnIpUpdate',
                meta: { menu: 'cntnIp', keepAlive: false },
                component: () => import('@/pages/cmsMng/configSetting/cntnIp/CntnIpUpdateView.vue'),
                props: true
            }
        ]
    },
    {
        path: 'work-group',
        redirect: { name: 'WorkGroupList' },
        children: [
            // 환경설정 > 권한관리 > 업무그룹관리
            {
                path: 'list',
                name: 'WorkGroupList',
                meta: { menu: 'wrkGroup', keepAlive: true },
                component: () => import('@/pages/cmsMng/configSetting/workGroup/WorkGroupListView.vue')
            },
            {
                path: 'add',
                name: 'WorkGroupInsert',
                meta: { menu: 'wrkGroup', keepAlive: false },
                component: () => import('@/pages/cmsMng/configSetting/workGroup/WorkGroupInsertView.vue')
            },
            {
                path: 'modify/:jobGroupId',
                name: 'WorkGroupUpdate',
                meta: { menu: 'wrkGroup', keepAlive: false },
                component: () => import('@/pages/cmsMng/configSetting/workGroup/WorkGroupUpdateView.vue'),
                props: true
            }
        ]
    },
    {
        path: 'prv-log',
        redirect: { name: 'PrvLogCntnList' },
        children: [
            // 개인정보페이지 접속관리 목록
            {
                path: 'cntn-list',
                name: 'PrvLogCntnList',
                meta: { menu: 'prvLog', keepAlive: false },
                component: () => import('@/pages/cmsMng/configSetting/prvLog/PrvLogCntnPageListView.vue')
            },
            // 엑셀(개인정보)다운로드 로그관리
            {
                path: 'excel-list',
                name: 'PrvLogExcelList',
                meta: { menu: 'prvLog', keepAlive: false },
                component: () => import('@/pages/cmsMng/configSetting/prvLog/PrvLogExcelDownListView.vue')
            },
            // 기관별담당자 권한부여 로그관리
            {
                path: 'inst-list',
                name: 'PrvLogInstList',
                meta: { menu: 'prvLog', keepAlive: false },
                component: () => import('@/pages/cmsMng/configSetting/prvLog/PrvLogInstListView.vue')
            },
            //직원별 부서지정 로그관리
            {
                path: 'empl-list',
                name: 'PrvLogEmplList',
                meta: { menu: 'prvLog', keepAlive: false },
                component: () => import('@/pages/cmsMng/configSetting/prvLog/PrvLogEmplListView.vue')
            },
            // 회원별 업무그룹 로그관리
            {
                path: 'mmbr-list',
                name: 'PrvLogMmbrList',
                meta: { menu: 'prvLog', keepAlive: false },
                component: () => import('@/pages/cmsMng/configSetting/prvLog/PrvLogMmbrListView.vue')
            },
        ]
    },
    {
        path: 'mng-user',
        redirect: { name: 'MngUserList' },
        children: [
            // 환경설정 > 관리자관리
            {
                path: 'list',
                name: 'MngUserList',
                meta: { menu: 'mngUser', keepAlive: true },
                component: () => import('@/pages/cmsMng/configSetting/mngUser/MngUserListView.vue')
            },
            {
                path: 'add',
                name: 'MngUserInsert',
                meta: { menu: 'mngUser', keepAlive: false },
                component: () => import('@/pages/cmsMng/configSetting/mngUser/MngUserInsertView.vue')
            },
            {
                path: 'modify/:mbrUnqId',
                name: 'MngUserUpdate',
                meta: { menu: 'mngUser', keepAlive: false },
                component: () => import('@/pages/cmsMng/configSetting/mngUser/MngUserUpdateView.vue'),
                props: true
            }
        ]
    },
    {
        path: 'msg-tmpl',
        redirect: { name: 'MsgTmplList' },
        children: [
            // 환경설정 > 메시지템플릿관리
            {
                path: 'list',
                name: 'MsgTmplList',
                meta: { menu: 'msgTmpl', keepAlive: true },
                component: () => import('@/pages/cmsMng/configSetting/msgTmpl/MsgTmplListView.vue')
            },
            {
                path: 'add',
                name: 'MsgTmplInsert',
                meta: { menu: 'msgTmpl', keepAlive: false },
                component: () => import('@/pages/cmsMng/configSetting/msgTmpl/MsgTmplInsertView.vue')
            },
            {
                path: 'modify/:msgId',
                name: 'MsgTmplUpdate',
                meta: { menu: 'msgTmpl', keepAlive: false },
                component: () => import('@/pages/cmsMng/configSetting/msgTmpl/MsgTmplUpdateView.vue'),
                props: true
            }
        ]
    },
    {
        path: 'inst-sys',
        redirect: { name: 'InstSysSetList' },
        children: [
            // 기관별시스템설정관리 목록
            {
                path: 'list',
                name: 'InstSysSetList',
                meta: { menu: 'instSysSet', keepAlive: true },
                component: () => import('@/pages/cmsMng/configSetting/instSysSet/InstSysSetListView.vue')
            },
            // 기관별시스템설정관리 등록
            {
                path: 'add',
                name: 'InstSysSetInsert',
                meta: { menu: 'instSysSet', keepAlive: false },
                component: () => import('@/pages/cmsMng/configSetting/instSysSet/InstSysSetInsertView.vue')
            },
            // 기관별시스템설정관리 수정
            {
                path: 'modify/:instId/:sysStngKey',
                name: 'InstSysSetUpdate',
                meta: { menu: 'instSysSet', keepAlive: false },
                component: () => import('@/pages/cmsMng/configSetting/instSysSet/InstSysSetUpdateView.vue'),
                props: true
            }
        ]
    },
    // 환경설정 > 로그인 보안 설정
    {
        path: 'login-sec',
        name: 'LoginSecMngr',
        meta: { menu: 'loginSecMngr', keepAlive: false },
        component: () => import('@/pages/cmsMng/configSetting/loginSecMngr/LoginSecMngrView.vue')
    },
    // 환경설정 > 월별 회원가입 현황
    {
        path: 'monthly-signup-stats',
        name: 'MonthlySignupStatsList',
        meta: { menu: 'monthlySignupStats', keepAlive: true },
        component: () => import('@/pages/cmsMng/configSetting/monthlySignupStats/MonthlySignupStatsListView.vue')
    }
]

export default routes